import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoPixelFormatInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { VideoPixelFormatEnum } from '../../../types/enums/VideoPixelFormatEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoPixelFormatInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in VideoPixelFormatEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key}`,
        value: `${VideoPixelFormatEnum[key as keyof typeof VideoPixelFormatEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoPixelFormat: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoPixelFormat: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="video-pixel-format-input">
      <div className="input-title">
        {t('producer.inputs.video-pixel-format.title')}
        <Help
          title="Video Pixel Format"
          text="<b>YUV 4:2:0 (Yuv420p):</b> Standard format for most streams. Provides good quality while keeping file sizes and bandwidth usage moderate.<br/><br/><b>YUV 4:2:0 10-bit (Yuv420p10le):</b> Higher color depth for more precise color representation, useful for content with gradients or color-sensitive video. May increase file size and bandwidth.<br/><br/><b>YUV 4:2:2 (Yuv422p):</b> Better color fidelity and less color compression, ideal for professional video applications. Higher data requirements than standard 4:2:0."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderVideoPixelFormat.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.video-pixel-format.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.video-pixel-format.footer')}</div>
    </div>
  );
};

export default React.memo(VideoPixelFormatInput);
